export function seoDestinationName(name) {
    return name.replace(/[,\s]+/g, '-');
}
